<script>
	import htmlStringToVueDom from '@/lib/html-string-to-vue-dom.js'

	export default {

		props: [`content`, `componentReference`],

		render(createElement) {
			const variable = htmlStringToVueDom(createElement, `<span>${this.content}</span>`, this.componentReference)
			return variable
		}

	}
</script>